import React from "react";
import { useHistory } from "react-router";
import FeatureExplanation from "../../components/FeatureExplanation";

const LockedWorkspaceByMembers: React.FC = () => {
  const history = useHistory();

  return (
    <FeatureExplanation
      title="Your workspace is locked"
      paragraphs={[
        "Your workspace currently has multiple team members, which is not supported by your workspace's current feature plan.",
        "To resolve this issue and unlock your workspace, there are three options:",
        <span>
          1.{" "}
          <b
            className="text-purple-300 cursor-pointer"
            onClick={() => {
              history.push("/workspace/settings/billing");
            }}
          >
            Upgrade
          </b>{" "}
          to the business plan
        </span>,
        <span>
          2.{" "}
          <b
            className="text-purple-300 cursor-pointer"
            onClick={() => {
              history.push("/workspace/settings/members");
            }}
          >
            Remove
          </b>{" "}
          team members
        </span>,
        <span>
          3.{" "}
          <b
            className="text-purple-300 cursor-pointer"
            onClick={() => {
              history.push("/workspace/settings/danger-zone");
            }}
          >
            Delete
          </b>{" "}
          this workspace
        </span>
      ]}
    ></FeatureExplanation>
  );
};

export default LockedWorkspaceByMembers;
